import { styled } from '@mui/material/styles';

export const StyledMobileOnly = styled('div')(({ theme }) => {
  return {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  };
});
